// extracted by mini-css-extract-plugin
export default {"test":"NavBarTest_test__eSYSh"};